<template>
    <PresentacionView path="update-presentation/" hideHistory
                      action-buttons-prefix="PresentacionUpdateActionButtons">
    </PresentacionView>
</template>

<script>
import store from '../../../app/store'
import PresentacionView from '../../presentacion/views/PresentacionView'

export default {
  components: {
    PresentacionView
  },

  beforeRouteEnter (to, from, next) {
    store.commit('hideLateralNav')
    next()
  }
}
</script>
